import { useEffect, useState } from 'react';
import { fetchAboutUs } from '../../infrastructure/api/about-us.api';
import type { AboutUsBody } from '../../application/types';

const emptyBody: AboutUsBody = { ua: '', en: '' };

export function useAboutUs() {
  const [body, setBody] = useState<AboutUsBody>(emptyBody);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    fetchAboutUs()
      .then(next => {
        if (!cancelled) {
          setBody(next);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setBody(emptyBody);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setIsLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { body, isLoading };
}
